style= require('./gameweeks.styl')

section.controls
  .panel
    .control
      if seasons
          ft-dropdown.dropdown(icon)
            header.dropdown-header(slot="header")
              if this.sport
                .dropdown-icon
                  ft-icon(name=`sports--${this.sport}`)
              span.dropdown-text=(this.sport) || 'All sports'
            each s in sports
              .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
                if s
                  .dropdown-icon
                    ft-icon(name=`sports--${s}`)
                span= s
      sporty-seasons(
        sport= this.sport,
        season=season,
        (change:season)=changeSeason(e),
        blank="<select a season>")
      .send-fixtures
        ft-button(success,
          disabled=season?.$isSubmitting,
          (click)=this.send(season, 'fixtures')
        )='Send Fixtures'
      .spacer
      ft-button.confirm(primary, disabled=$isSubmitting, (click)=this.save())='Save'
ft-toggle(
  checked=this.lockedGameweeks,
  (change)=this.changeGWLockStatus()
)='Lock status'
section.gameweeks
  header.round-header
    .round= `Season`
    .spacer
    ft-button(warning, (click)=this.auto()) Auto Assign
    ft-button(danger, (click)=this.reset()) Full Reset
  - var round
  each match in realMatches
    if round !== match.round
      - round = match.round
      header.round-header
        .round= `Round ${round}`
        .spacer
        if round > 1
          ft-button(danger, (click)=this.removeRound(match.round)) Delete
    .match
      if match.isDuel
        .name
          .home= match.homeTeam.name
          .away= match.awayTeam.name
      else
        .name= match.name
      .round= match.round
      .time= moment(match.startTime).format('lll')
      ft-button(warning, (click)=this.addRound(match)) Split
